module.exports = __webpack_public_path__ + "586d7ee4523dc8404dfc1caaff83e263.ttf";